import React from 'react';
import { useTranslation } from 'react-i18next';
import { FallbackProps } from 'react-error-boundary';
import { Button, helperMargin, Modal, Typography, Separator } from '@utex/ui-kit';
import { Layout } from '../Layout';
import { Container, Icon } from './styles';

import iconTurtle from './static/img/turtle.svg';

export const SomethingWentWrongModal: React.FC<FallbackProps> = ({ resetErrorBoundary, error }) => {
  const { t } = useTranslation('deposit');

  return (
    <Modal isOpen={true} size={960}>
      <Layout title={t('Deposit')}>
        <Container>
          <Icon src={iconTurtle} alt="" />

          <Typography.Title level={2}>{t('Something went wrong')}</Typography.Title>

          <Separator />

          <Typography.Paragraph>
            {error?.message || t('Please try again later')}
          </Typography.Paragraph>

          <Button view="extra-dim" onClick={resetErrorBoundary} css={helperMargin({ top: 20 })}>
            {t('Try again')}
          </Button>
        </Container>
      </Layout>
    </Modal>
  );
};
